import {
  CheckIsBakIntegrationPayload,
  CheckIsBakIntegrationSuccessResponse,
  CheckIsBakIntegrationErrorResponse,
  checkIsBakIntegrationApi,
} from 'IntegrationModule/api/checkIsBakIntegrationApi';
import { useAppQuery } from 'core/query/hooks/useAppQuery';
import { integrationQueryKeys } from './integrationQueryKeys';
import { FIVE_MINUTES } from '@constants';

export const useCheckIsBakIntegrationQuery = (params: CheckIsBakIntegrationPayload) => {
  const { data: queryData, ...isBakIntegrationQuery } = useAppQuery<
    CheckIsBakIntegrationSuccessResponse,
    CheckIsBakIntegrationErrorResponse
  >({
    queryKey: integrationQueryKeys.detail({
      ...params,
      identifier: `useCheckIsBakIntegrationQuery`,
    }),
    queryFn: async ({ token }) => {
      const response = await checkIsBakIntegrationApi({ params, token });
      return response.data as CheckIsBakIntegrationSuccessResponse;
    },
    staleTime: FIVE_MINUTES,
  });

  const isBakIntegrationData = queryData?.data;
  const isBakIntegrationError = isBakIntegrationQuery?.error;

  return {
    isBakIntegrationData,
    isBakIntegrationError,
  };
};
